import axios from 'axios';
import { keepPreviousData, useMutation, useQuery } from '@tanstack/react-query';

export const useWalletVerificationSession = (hash?: string) => {
  const data = useQuery({
    queryKey: ['wallet-verification-session'],
    queryFn: async () => {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/wallet-ownership/${hash}`);
      return res.data;
    },
    enabled: !!hash,
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60,
  });

  return data;
};

export const useConfirmWalletVerification = () => {
  const mutation = useMutation({
    mutationKey: ['confirm-wallet-verification'],
    mutationFn: async ({ sessionId, signature, hash }: { hash: string; signature: string; sessionId: string }) => {
      const res = await axios.post(`${process.env.REACT_APP_BACKEND_API_URL}/wallet-ownership/${hash}`, {
        signature,
        session_id: sessionId,
      });
      return res.data;
    },
  });
  return {
    confirmWalletVerification: mutation.mutateAsync,
    isPending: mutation.isPending,
  };
};
